export default __webpack_public_path__ + "static/media/lobby_second_image.5f8a1804.jpg";